<template>
    <div class="horizontal-scroll">
        <div v-if="is_api_calling" class="d-flex justify-content-center align-items-center">
            <half-circle-spinner :animation-duration="1000" :size="60" color="#00448b" />
        </div>
        <div v-else>
            <div class="tab-list d-flex align-items-center justify-content-between">
                <ul class="d-flex align-items-center pl-0 mb-0">
                    <li class="d-flex align-items-center px-3" >
                        <span class="list-text text-new-blue">General</span>
                    </li>
                </ul>
            </div>
            <div class="content mt-3">
                <div class="row">
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="form-group contactGroup">
                            <div class="w-100" style="position: relative;">
                                <label class="inputLabel fs-14 fw-600 text-black">SLA Working Days <span class="text-danger">*</span></label>
                                <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" data-vv-as="SLA Working Days" maxlength="3" name="sla_working_days" v-model="sla_working_days" type="number" autocomplete="off" placeholder="SLA Working Days" />
                                <span class="inputBorder"></span>
                            </div>
                        </div>
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('sla_working_days')">{{errors.first('sla_working_days')}}</span>
                    </div>
                    <div class="col-lg-4 col-md-6 col-sm-12">
                        <div class="form-group contactGroup">
                            <div class="w-100" style="position: relative;">
                                <label class="inputLabel fs-14 fw-600 text-black">Archive After Days <span class="text-danger">*</span></label>
                                <input class="inputFieldNew inputFieldNew-padding" v-validate="'required'" data-vv-as="Archive After Days" maxlength="3" name="archive_after_days" v-model="archive_after_days" type="number" autocomplete="off" placeholder="Archive After Days" />
                                <span class="inputBorder"></span>
                            </div>
                        </div>
                        <span class="invalid-feedback-form text-danger" v-show="errors.has('archive_after_days')">{{errors.first('archive_after_days')}}</span>
                    </div>
                </div>
            </div>
            <div class="d-flex align-items-center justify-content-center my-4">
                <!-- <button type="button" class="btn btn-danger-new" @click="goToListView" >Cancel</button> -->
                <button type="button" class="btn btn-success ml-4 text-capitalize fw-500 text-white" :disabled="is_api_calling || save_loader" :class="{'text-align-left' : save_loader}" @click="createSuccess" style="width: 150px">
                    {{ save_loader ? 'Saving' : 'Save' }}
                    <half-circle-spinner v-if='save_loader' :animation-duration="1000" :size="20" color="#00448b" style="margin: 0 auto;top:-25px;left:30px" />
                </button>
            </div>
        </div>
        <sweet-modal ref="success_modal" icon="success">{{success_msg}}</sweet-modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
import { HalfCircleSpinner } from "epic-spinners";
import dynamic_template from '../../mixins/dynamic_template'
import { SweetModal } from 'sweet-modal-vue';
export default {
    mixins: [dynamic_template],
    components: {
        SweetModal,
        HalfCircleSpinner
    },
    data() {
        return {
            success_msg:'',
            warning_msg:'',
            sla_working_days: 0,
            archive_after_days: 0,
            is_api_calling: false,
            general_settings_id: '',
            save_loader: false,
        }
    },
    methods: {
        async createSuccess() {
            this.$validator.validateAll().then(async result => {
                if (result) {
                    this.saveData();
                } else {

                }
            });
        },
        async saveData() {
            // this.is_api_calling = true;
            this.save_loader = true
            try {
                let response = await this.updateDynamicGeneralSettings(this.create_data);
                this.success_msg = response.response
                this.$refs.success_modal.open();
                setTimeout(() => {
                    this.$refs.success_modal.close();
                    this.save_loader = false
                    this.getListData();
                }, 3000);
            }
            catch (error) {
                this.warning_msg = err;
                this.$refs.warning_modal.open();
                // this.is_api_calling = false;
                this.save_loader = false
            }
        },
        async getListData() {
            this.is_api_calling = true;
            try {
                let params = {
                    limit: 10,
                    skip: 0,
                    sort_key: "",
                    sort_value: 1
                };
                let response = await this.listDynamicGeneralSettings(params);
                if(response.response.length > 0){
                    this.sla_working_days = response.response[0].sla_work_days;
                    this.archive_after_days = response.response[0].archive_after_days
                    this.general_settings_id = response.response[0]._id;
                }
                this.is_api_calling = false;
            }
            catch (error) {
                this.warning_msg = error;
                this.$refs.warning_modal.open();
            }
        }
    },
    mounted() {
        this.getListData();
    },
    computed: {
        create_data() {
            return {
                _id: this.general_settings_id,
                general: {
                    archive_after_days: this.archive_after_days,
                    sla_work_days: this.sla_working_days
                }
            }
        }
    },
    created(){
        const dict = {
            custom: {
                sla_working_days:{
                    required:() => "SLA working days is Required",
                },
                archive_after_days:{
                    required:() => "Archive after days is Required",
                },
            }
        }
        this.$validator.localize("en", dict);
    }
}
</script>
<style scoped>
.horizontal-scroll{
    overflow-x: hidden;
}
.text-align-left{
    text-align: left !important;
}
</style>